import axios from "axios";
import { config } from "@/config/constants.js";
import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "sales",
    object: "sale",
    header: [
      //{ text: "ID", value: "id" },
      { text: "Date", value: "created_at", sortable: true },
      { text: "Name", value: "client_id", sortable: true },
      { text: "Guard", value: "guard_id", sortable: true },
      { text: "#Product", value: "order_id", sortable: true },
      { text: "Tax", value: "tax", sortable: true },
      { text: "Payment Method", value: "payment_method", sortable: true },
      { text: "Total", value: "amount", sortable: true },
      { text: "Status", value: "pay_status", sortable: true },
      { text: "Actions", value: "actions", sortable: false }
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    get_payment({ commit, state }, options) {
      console.log('options');
      console.log(options);
      return new Promise((resolve, reject) => {
        commit("request");
        let filter = {
          ...options
          /* search: ""*/
        };
        axios
          .get(config.api_url.replace('/admin/','/') + "get_payment", {
            params: filter
          })
          .then(response => {
            commit("success", {
              list_: response.data,
              total_: parseInt(
                response.headers["pagination-count"]
              )
            });
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    },
    getListTotal({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");

        let filter = {          
          search: "",
          ...options,
        };

        axios
          .get(config.api_url + "sales_all", { params: filter })
          .then((response) => {
            commit("success", {
              list_total: response.data,
            });
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
